module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir8-7f37cb9d6785e1363fa5827f4db7e13e.jpg";